import { Resource } from "i18next";
import t from "../../locales/de.json";

export default t as Resource;
